if (!customElements.get('prop-65-drawer')) {
  const SELECTOR = {
    DRAWER_CONTENT: '.js-disclaimer-drawer',
    DRAWER_TOGGLE: '.js-show-disclaimer'
  }
  const ATTRIBUTE = {
    CURRENT_VARIANT_ID: 'current-variant-id',
    VARIANT_DISCLAIMERS: 'variant-disclaimers',
  }
  const EVENT = {
    PRODUCT_VARIANT_CHANGE: 'product:variant-change'
  }
  /* global SideDrawer */
  class Prop65Drawer extends SideDrawer {
    constructor() {
      super();
      this.clickHandler = this.openDrawer.bind(this);
      this.drawer = document.querySelector(SELECTOR.DRAWER_CONTENT);
      this.disclaimers = this.drawer.querySelectorAll('.prop65-disclaimer-text');
      this.querySelector(SELECTOR.DRAWER_TOGGLE).addEventListener('click', this.clickHandler );
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.disclaimers) {
        // Bind to on:variant:change event for this product
        const variantPicker = document.querySelector('.product').querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }
        
        if (this.dataset.currentVariantId) {
          this.setVisibleText(this.dataset.currentVariantId);
        }
      }

    }

    setVisibleText(variantId) {
      this.disclaimers.forEach((disclaimer) => {
        disclaimer.hidden = disclaimer.dataset.variantId.toString() !== variantId.toString();
      });
    }
    handleVariantChange(evt) {
      this.setVisibleText(evt?.detail?.variant?.id || 0);
    }
    openDrawer() {
      this.drawer && this.drawer.open();
    }
  }

  customElements.define('prop-65-drawer', Prop65Drawer);
}
